import React, { useRef, useEffect, useState, useMemo } from 'react';
import { observer } from 'mobx-react';
import { GlossaryHelpPageVM } from './GlossaryHelpPageVM';
import { GlossaryHelpSummary } from './GlossaryHelpPageSummary';
import { mdiMagnify } from '@mdi/js';
import Icon from '@mdi/react';
import './GlossaryHelpPage.scss';
import { LinkComp } from '../Links/extLink';
import { Input } from 'cd-eft/components/common/Input';
import { Popup } from 'cd-eft/components/common/Popup';
import { Table } from 'reactstrap';
import { htmlParser } from 'cd-eft/utils/stringUtilities';
import {
  mdiPencil,
  mdiTrashCanOutline,
  mdiPlusCircle,
  mdiLinkPlus
} from '@mdi/js';
import { RTEComponent } from 'cd-eft/_stories_/RichTextEditor/RTE/RTE';
import { Checkbox } from 'cd-eft/components/common/Checkbox/Checkbox';

import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';

// const libraryStore = stores.AppStore.projectsLibraryStore;
interface IGlossaryAddEdit{
  vm: GlossaryHelpPageVM,
}
const GlossaryHelpComponent = (props) => {
  const vm = useRef(new GlossaryHelpPageVM()).current;

  const [query, setQuery] = useState('')
  const [finalQuery, setFinalQuery] = useState(query)
  const [errorMessage, setErrorMessage] = useState(false)
  const [whatCategory, setWhatCategory] = useState('  ')

  // Get glossary data on page render
  useEffect(() => {
    vm.getGlossaryData();
    vm.getGlossaryDataByCategorySummary();
    // console.log('glossary useEffect');
  }, []);


  // Get glossary data on summary
  useEffect(() => {
    if (whatCategory === '') {
      vm.getGlossaryDataByCategory(' ')
    }
    if (whatCategory === 'all' || whatCategory === '  ') {
      vm.getGlossaryData()
    } else {
      vm.getGlossaryDataByCategory(whatCategory);
    }
  }, [whatCategory]);

  //Get the summary of glossary data on click
  const updateSummaryName = (newSummary) => {
    setWhatCategory(newSummary)
  }
  // commented because it does not work.
  // const handleScroll = () => {
  //   document.querySelector('#main')!.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  // }

  const handleChange = (e) => {
    setQuery(e.target.value)
    setErrorMessage(false)
  }

  const handleSearch = (e) => {
    e.preventDefault()
    handleErrorMessage(e)
  }

  const handleErrorMessage = (e) => {

    const searchedArr = vm.glossaryData?.map((section, index) => {
      return (
        section.data.filter((item) => {
          return query.toLowerCase() === '' ? item : item.glossaryDescription?.toLowerCase().includes(query.toLowerCase()) || (item.glossaryTitle?.toLowerCase().includes(query.toLowerCase()))
        })?.length)
    })
    searchedArr?.includes(1) && query.length ? setErrorMessage(false) : setErrorMessage(true)
  }
  return (
    // <div className="glossary-container ">
    <div className={`${props.adminContent ? '' : 'glossary-container'}`}>
      {vm.loader && <Loader></Loader>}
      {props.adminContent ? (
        <div className='action-menu-wrapper glossy-wrapper'>
          { vm.glossaryAddEditMode !== 'add' && vm.glossaryAddEditMode !=='edit' && <button className='usa-button usa-button--outline add-card add-glossy' aria-label='add glossary/help' data-testid= 'add-glossary' onClick={vm.onClickAddGlossary}><Icon path={mdiPlusCircle} size={1} />  Add</button>}
          {vm.glossaryAddEditMode !== 'add' && <button className='usa-button usa-button--unstyled btn1 delete-glossy' aria-label='delete glossary/help' data-testid= 'delete-glossary' onClick={vm.onClickToggleDeleteGlossary}><Icon path={mdiTrashCanOutline} size={1} />  Delete </button>}
        </div>
      ) :
        whatCategory === '  ' || whatCategory === 'all' ? <h1 tabIndex={0}>Glossary and Help</h1> : <h1 tabIndex={0}>{whatCategory}{!whatCategory ? 'No' : null} Category</h1>}

      {!props.buttomContainer && (vm.glossaryAddEditMode === null || vm.glossaryAddEditMode === 'delete') &&
        <div className='glossary-body' id='glossary-body'>
          <form className={`${props.adminContent ? 'input-group pl-2 flex-nowrap release-notes-card' : 'input-group pl-2 flex-nowrap'}`} role="search">
            <input
              id='input_text_value'
              className={`usa-input search-input usa-input-change error-textbox-${errorMessage}`}
              name="filterString"
              type="text"
              aria-label="Search for Keywords"
              placeholder="Search for Keywords"
              onChange={handleChange}
            />
            <button className="usa-button p-0 pl-1 pr-1 input-group-append input-group-append-new icon" onClick={handleSearch} >
              <Icon path={mdiMagnify} title="Search" size={1.5} color="white" />
            </button>
          </form>
          {errorMessage ?
            <label className='error-message' role='alert' aria-invalid='true' aria-describedby='input_text_value'>Please enter a keyword or try a different search</label> : null}


          <div className={`${props.adminContent ? 'usa-in-page-nav-container release-notes-card' : 'usa-in-page-nav-container'}`}>
            <aside
              className="usa-in-page-nav"
              data-title-text="On this page"
              data-title-heading-level="h4"
              data-scroll-offset="0"
              data-root-margin="0px 0px 0px 0px"
              data-threshold="1"
            >
              {props.adminContent ? null : <GlossaryHelpSummary className="glossary-help-summary" glossData={vm.uniqCatogeries} updateSummaryName={updateSummaryName} handleScroll={vm.handleScroll} />}
              <h2 className="usa-in-page-nav__heading glossary-search-heading" tabIndex={0}>
                Select a letter to view words starting with that letter:
              </h2>
              <nav aria-label="On this page" className="usa-in-page-nav__nav glossary-search-heading" role='navigation'>
                <div>
                  {vm.glossaryData?.map((section) => {
                    return (
                      section.enabled ?
                        <a key={section.letter + '-link'}
                          href={`#section_${section.letter.toLocaleUpperCase()}`}
                          className={`usa-in-page-nav__link glossary-details`}
                          id={`${section.letter}-header`}
                        >
                          {section.letter}
                        </a> : <span className={`usa-in-page-nav__link glossary-details enabled-${section.enabled}`} key={section.letter + '-link'}>{section.letter}</span>
                    );
                  })}
                </div>
              </nav>
            </aside>
            <div id="main-content-glossary-help" className="main-content usa-prose">
              {vm.glossaryData?.map((section, index) => {
                return (
                  section.data.length ?
                    <div className='glossary-description' key={'section-' + index}>

                      {section.data.filter((item) => {
                        return query.toLowerCase() === '' ? item : item.glossaryDescription?.toLowerCase().includes(query.toLowerCase()) || (item.glossaryTitle?.toLowerCase().includes(query.toLowerCase()))
                      })?.length ? <h2 className="titleHeader" key={`section_${section.letter.toLocaleUpperCase()}`} tabIndex={0} id={`section_${section.letter.toLocaleUpperCase()}`} >{section.letter}</h2> : null}

                      {section.data.filter((item) => {
                        return query === '' ? item : item.glossaryDescription?.toLowerCase().includes(query.toLowerCase()) || (item.glossaryTitle?.toLowerCase().includes(query.toLowerCase()))
                      }).map((item, index) => <React.Fragment  key={`${item.glossaryId}-link-${index}`}>
                        <hr />
                        {
                          vm.glossaryAddEditMode === 'delete'? 
                          <Checkbox id={`${item.glossaryId}-checkbox-${index}`} key={`${item.glossaryId}-checkbox-${index}`} name={`${item.glossaryId}-checkbox-${index}`} checked={vm.seletedDeleteGlossaries.includes(item.glossaryId!)} onChange={()=>vm.onChangeCheckDeleteGlossary(item.glossaryId!)} label={item.glossaryTitle}/>
                          :<div className="glossary-entry" key={`${item.glossaryId}-checkbox-${index}`}>
                              <h3 className="title" tabIndex={0}>
                                {item.glossaryTitle}&nbsp;&nbsp;&nbsp;{props.adminContent ? <button className='usa-button--unstyled' onClick={()=>vm.onClickEdit(item.glossaryTitle!, item.glossaryDescription!, item.glossaryLinkResponseDto!, item)}> <Icon path={mdiPencil} size={1} /> Edit</button> : null}
                              </h3>
                              <div tabIndex={0} id={`glossary_description${index}-${item.glossaryId}`}>{htmlParser(item.glossaryDescription!)}</div>
                              {
                                item.glossaryLinkResponseDto?.map((link, linkIndex) => (
                                <LinkComp key={`${item.glossaryId}-link-${linkIndex}`} label={link.glossaryLinkDescription} labelClass={link.glossaryLink} id={`${item.glossaryId}-link-${linkIndex}`} />
                                ))
                              }
                            < button className="usa-button usa-button-new usa-button--unstyled" onClick={vm.handleScroll}>Back to Top</button>
                          </div>
                        }
                       
                      </React.Fragment>
                      )}
                    </div> : null)
              })}
              { vm.glossaryAddEditMode === 'delete' && (
              <div className="del-button-container">
                <button
                  className="usa-button usa-button--outline"
                  onClick={vm.onClickToggleDeleteGlossary}
                  aria-label="Cancel"
                >
                  Close
                </button>

                {vm.seletedDeleteGlossaries.length ? (
                  <button className="usa-button" 
                    onClick={vm.onClickDeletePopup} 
                    aria-label="Delete"
                  >
                    Delete
                  </button>
                ) : null}
              </div>
            )}
            </div>
          </div>
          <br />
          <br />
        </div> }
      {!props.buttomContainer && (vm.glossaryAddEditMode === 'add' || vm.glossaryAddEditMode === 'edit' ) && <GlossaryHelpAddEditComponent vm={vm} />
        }
       {vm.deletePopup ? (
              <div>
                {vm.seletedDeleteGlossaries.length ? (
                  <div className="delete-popup">
                    <Popup
                      trigger={vm.deletePopup}
                      setTrigger={vm.onClickDeletePopup}
                      title="Delete Glossary?"
                      handleCancel={vm.onClickDeletePopup}
                      cancelText="Close"
                      handleOK={vm.deleteGlossaryHandler}
                      okText="Delete"
                    >
                      {vm.seletedDeleteGlossaries.length === 1 ? (
                        <p>Are you sure you want to delete this glossary item?</p>
                      ) : (
                        <p>Are you sure you want to delete these glossary items?</p>
                      )}
                      {vm.seletedDeleteGlossaries.map((id) => (
                        <div className='glossary-delete-comment-wrapper'>
                          <Table borderless>
                            <tbody>
                              <tr>
                                <th >Title</th>
                                <td className="">{vm.glossaryDictionary[id].glossaryTitle}</td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      ))}
                    </Popup>
                  </div>
                ) : null}
              </div>
            ) : null}
         
    </div>


  );
};

const GlossaryHelpAddEditComponent = observer((props: IGlossaryAddEdit) => {
  const initialRTEString = useRef(props.vm.retGlossaryText).current;
  return (
    <>
    {props.vm.rteLoading && <Loader></Loader>}
    <div className='glossary-body-rte '>
      <Input
        className={props.vm.rteGlossaryNameErrorMessage? 'usa-input--error': ''}
        idAndName='glossary-name'
        label='Glossary Name'
        wrapperClassName='glossary-name'
        valid={true}
        value={props.vm.rteGlossaryName}
        type='text'
        required ={true}
        onChange={props.vm.onChangeGlossaryName}
        onBlur={props.vm.onBlurValidation}
        errorMsg={props.vm.rteGlossaryNameErrorMessage}
      />

      <div data-testid='rte-container'>
        <label className={"usa-label rte-label"}>
          Description
        </label>
        {/* <RTEComponent saveCallback={props.vm.rteTextCallBack} initialValue={`${props.vm.retGlossaryText}`} contentString={props.vm.retGlossaryText} /> */}
        <RTEComponent saveCallback={props.vm.rteTextCallBack} initialValue={initialRTEString} contentString={props.vm.retGlossaryText} onBlur={props.vm.onBlurValidation}/>
          <span
            className="usa-error-message"
            role="alert"
            hidden={!props.vm.retGlossaryTextErrorMessage}
            aria-live="polite"
          >
            {props.vm.retGlossaryTextErrorMessage}
          </span>
      </div>
      <div className='url-container'>
        {props.vm.glossaryUrlLink.map((e, i) => {
          return <div key={`urlLink-${i}`}>
            <div className={`url-${i} url`}>
              <label className='usa-label'>Text:</label>
              <div className='usa-input-block'>
              <input className={e.errorMessage.textErrorMessage? 'usa-input--error': 'usa-input'} value={e.text} onChange={(event) => props.vm.glossaryUrlOnChange(i, 'text', event.target.value)} onBlur={props.vm.onBlurValidation} name={`glossary-link-title-${i}`}></input>
                <span
                  className="usa-error-message"
                  role="alert"
                  hidden={!e.errorMessage.textErrorMessage}
                  aria-live="polite"
                >
                  {e.errorMessage.textErrorMessage}
                </span>
              </div>
              <button className='usa-button--unstyled' onClick={() => props.vm.onClickDeleteUrl(i)}><Icon path={mdiTrashCanOutline} size={1} /></button>
            </div>
            <div className={`url-${i} url`}>
              <label className='usa-label'>URL Link:</label>
              <div className='usa-input-block'>
              <input className={e.errorMessage.urlErrorMessage? 'url-link-input usa-input--error ': 'usa-input url-link-input'} value={e.url} onChange={(event) => props.vm.glossaryUrlOnChange(i, 'url', event.target.value)} onBlur={props.vm.onBlurValidation} name={`glossary-link-url-${i}`}></input>
              <span
                  className="usa-error-message"
                  role="alert"
                  hidden={!e.errorMessage.urlErrorMessage}
                  aria-live="polite"
                >
                  {e.errorMessage.urlErrorMessage}
                </span>
              </div>
            </div>
          </div>
        }
        )
        }
      </div>
      <button className='add-button usa-button--unstyled' onClick={props.vm.onClickAddMoreUrl}><Icon path={mdiLinkPlus} size={1} />&nbsp;<u>Add More</u></button>
      <div className='buttons-group'>
        <button className='usa-button usa-button--outline' onClick={props.vm.handleGlossaryCancel} disabled={props.vm.rteLoading}>Close</button>
        <button className='usa-button' onClick={props.vm.handleGlossarySave} disabled={props.vm.rteDisableSaveButton || props.vm.rteLoading}>Save</button>
      </div>
    </div>
    </>
  )
})

export const GlossaryHelp = observer(GlossaryHelpComponent);

